import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface ISaveTaskData {
  id: string;
  name: string;
  description: string;
  jobs: Array<string | number>;
}

const saveTask = ({ id, ...postData }: ISaveTaskData) => {
  if (id) {
    const newEndpoints = endpoints.task.tasksById.replace('{id}', id);
    return http().put(newEndpoints, postData);
  } else {
    return http().post(endpoints.task.base, postData);
  }
};

export function useSaveTask() {
  return useMutation({ mutationFn: saveTask });
}
